// import device from "current-device";

export class WindowInfo {
    constructor() {
        if (!WindowInfo.instance) {
            this.updateDimensions();

            this.handleResize = this.throttledUpdate();
            window.addEventListener("resize", this.handleResize.bind(this));
            WindowInfo.instance = this;
        }
        return WindowInfo.instance;
    }

    updateDimensions() {
        let width = null;
        let height = null;

        width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        height = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

        document.body.style.setProperty("--vw", `${width}`);
        document.body.style.setProperty("--vh", `${height}`);

        // if (device.type === "desktop") {
        // }
        // if (device.type === "mobile") {
        //     // Make this a singleton for devices
        //     if (!document.documentElement.classList.contains("has-heightcalced")) {
        //         document.documentElement.classList.add("has-heightcalced");

        //         // Add a sizer element
        //         const sizer = document.createElement("div");

        //         sizer.classList.add("sizer");
        //         sizer.style.cssText = "position:fixed;top:0;left:0;width:100%;height:100vh;height:100svh;z-index:-1;";
        //         document.body.appendChild(sizer);

        //         width = document.querySelector(".sizer").clientWidth;
        //         height = document.querySelector(".sizer").offsetHeight;

        //         document.body.style.setProperty("--vw", `${width}`);
        //         document.body.style.setProperty("--vh", `${height}`);

        //         const event = new CustomEvent("resizing", { detail: { width, height } });
        //         document.dispatchEvent(event);
        //     }
        // }

        const event = new CustomEvent("resizing", { detail: { width, height } });
        document.dispatchEvent(event);
    }

    throttledUpdate() {
        let ticking = false;
        return () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    this.updateDimensions();
                    ticking = false;
                });
                ticking = true;
            }
        };
    }

    destroy() {
        // document.documentElement.querySelector(".sizer").remove();
        window.removeEventListener("resize", this.handleResize);
    }
}
